@if (renderError()) {
  <div class="flex justify-center h-full w-full p-4">
    <span>{{ '#UI_CORE.COMPONENTS.PDF_VIEWER.LOAD_ERROR' | translate }}</span>
  </div>
} @else if (!isLoading()) {
  @if (resolvedDocument()) {
    <div class="flex flex-col h-full items-center justify-center">
      <div class="overflow-auto h-full w-full flex flex-col">
        <canvas class="mx-auto" #container></canvas>
      </div>
      <div class="sticky mx-auto bottom-[10%] z-10 opacity-20 hover:opacity-80">
        <button class="soft-button secondary" (click)="zoomOut()">
          <soft-ds-icon name="fa-regular fa-magnifying-glass-minus" />
        </button>
        <button class="soft-button secondary" (click)="zoomIn()">
          <soft-ds-icon name="fa-regular fa-magnifying-glass-plus" />
        </button>
        <button
          class="soft-button secondary"
          [disabled]="currentPage() <= 1"
          (click)="prevPage()"
        >
          <soft-ds-icon name="fa-regular fa-arrow-up" />
        </button>
        <button
          class="soft-button secondary"
          [disabled]="currentPage() > pages() - 1"
          (click)="nextPage()"
        >
          <soft-ds-icon name="fa-regular fa-arrow-down" />
        </button>
      </div>
    </div>
  } @else {
    <div class="flex justify-center h-full w-full p-4">
      <span>{{ '#UI_CORE.COMPONENTS.PDF_VIEWER.NO_DOCUMENT' | translate }}</span>
    </div>
  }
} @else {
  <div class="flex items-center justify-center h-full w-full">
    <soft-ds-icon name="fa-regular fa-spinner fa-spin" size="xl" class="color-light" />
  </div>
}
